module.exports = __webpack_public_path__ + "static/media/popularSpaceBadge.86c10a4f.svg";